export default __webpack_public_path__ + "static/industryintegrationImg-16dc573b5fdf11ed8c05f80b1e55e3d8.png";